var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99167 10.9953L1.85168 9.85531C1.38668 9.39031 1.38668 8.6253 1.85168 8.1603L2.99167 7.02029C3.18667 6.82529 3.34417 6.44279 3.34417 6.17279V4.56027C3.34417 3.90027 3.88418 3.36029 4.54418 3.36029H6.15667C6.42667 3.36029 6.80918 3.20281 7.00418 3.00781L8.14417 1.86779C8.60917 1.40279 9.37418 1.40279 9.83918 1.86779L10.9792 3.00781C11.1742 3.20281 11.5567 3.36029 11.8267 3.36029H13.4392C14.0992 3.36029 14.6392 3.90027 14.6392 4.56027V6.17279C14.6392 6.44279 14.7967 6.82529 14.9917 7.02029L16.1317 8.1603C16.5967 8.6253 16.5967 9.39031 16.1317 9.85531L14.9917 10.9953C14.7967 11.1903 14.6392 11.5728 14.6392 11.8428V13.4553C14.6392 14.1153 14.0992 14.6553 13.4392 14.6553H11.8267C11.5567 14.6553 11.1742 14.8128 10.9792 15.0078L9.83918 16.1478C9.37418 16.6128 8.60917 16.6128 8.14417 16.1478L7.00418 15.0078C6.80918 14.8128 6.42667 14.6553 6.15667 14.6553H4.54418C3.88418 14.6553 3.34417 14.1153 3.34417 13.4553V11.8428C3.34417 11.5653 3.18667 11.1828 2.99167 10.9953Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.25L11.25 6.75",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8709 10.875H10.8776",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12088 7.125H7.12762",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.d4800872a54d16754acff796b9de4caa.svg";
export { ForwardRef as ReactComponent };